module.exports = __webpack_public_path__ + "static/media/starts_with_l.06a4de16.mp3";